var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-container"},[_c('span',[_vm._v(_vm._s(_vm.groupHeader))]),_c('v-layout',{attrs:{"wrap":"","fill-width":""}},[_vm._t("group-content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }